import type { TooltipRenderProps } from 'react-joyride';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';

export function MetricsPageTourTooltip({
  tooltipProps,
  step,
  index,
  size,
  isLastStep,
  backProps,
  primaryProps,
  skipProps,
}: TooltipRenderProps) {
  return (
    <Card {...tooltipProps} className="w-[360px] max-w-[calc(100vw-2rem)]">
      <CardContent className="p-3">
        <div className="text-sm">{step.content}</div>
      </CardContent>
      <CardFooter className="flex items-center justify-start gap-2 p-3 pt-0">
        <span className="text-xs text-muted-foreground">
          {index + 1} / {size}
        </span>
        {!isLastStep ? (
          <Button
            variant="ghost"
            size="auto"
            className="h-7 px-2 text-xs"
            {...skipProps}
          >
            {skipProps.title}
          </Button>
        ) : (
          <span />
        )}
        <div className="flex-grow"></div>
        <div className="flex items-center gap-1.5">
          {index > 0 ? (
            <Button
              variant="ghost"
              size="auto"
              className="h-7 px-2 text-xs"
              {...backProps}
            >
              {backProps.title}
            </Button>
          ) : null}
          <Button size="auto" className="h-7 px-2 text-xs" {...primaryProps}>
            {primaryProps.title}
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
}
